export default __webpack_public_path__ + "images/f824b541a70da07395c845ed28711cfe.png";